const BASE_URL = process.env.REACT_APP_BACKEND
// const BASE_URL = 'https://backend.carepay.money/'
// const BASE_URL = 'https://uatbackend.carepay.money/'


const APIS = {

    SEND_OTP: BASE_URL + 'generateOtp?phoneNumber=',
    VERIFY_OTP: BASE_URL + 'verifyDashboardOtp?phoneNumber=',
    CHECK_ROLE_SCOUT: BASE_URL + 'checkRoleBasedOnNumber?phoneNumber=',
    GET_SCOUT_DATA_BY_SCOUT_ID: BASE_URL + 'getAllLoanDetailForScout?scoutId=',
    GET_DOCTOR_DATA_BY_ID: BASE_URL + 'getAllLoanDetailForDoctor?doctorId=',
    GET_PARENT_DOCTOR_DATA_BY_ID: BASE_URL + 'getAllLoanDetailForParentDoctor?parentDoctorId=',
    GET_PARENT_SCOUT_DATA_BY_ID: BASE_URL + 'getAllLoanDetailForParentScout?parentScoutId=',
    GET_GRAPH_DATA_BY_SCOUT_ID: BASE_URL + 'getTrendGraphForScout?scoutId=',
    GET_PARENT_SCOUT_DATA_GRAPH: BASE_URL + 'getTrendGraphForParentScout?parentScoutId=',
    GET_MONTHLY_LEADS_BY_PARENT_DOCTOR_ID: BASE_URL + 'getMonthlyLeadsPerClinicParentDoctor?parentDoctorId=',
    GET_MONTHLY_LEADS_BY_DOCTOR_ID: BASE_URL + 'getMonthlyLeadsPerClinicDoctor?doctorId=',
    GET_MONTHLY_LEADS_BY_SCOUT_ID: BASE_URL + 'getMonthlyLeadsPerClinicForScout?scoutId=',
    GET_MONTHLY_LEADS_BY_PARENT_SCOUT_ID: BASE_URL + 'getMonthlyLeadsPerClinicParentScout?parentScoutId=',
    GET_TOTAL_LOANS_BY_SCOUT_ID: BASE_URL + 'getLoanAmountAndCountForScout?scoutId=',
    GET_TOTAL_LOANS_BY_DOCTOR_ID: BASE_URL + 'getLoanCountAndAmountForDoctor?doctorId=',

    GET_LOAN_DETAILS_BY_USER_ID: BASE_URL + 'getProductDetailByUserId?userId=',
    GET_POTENTIAL_BY_SCOUT_ID: BASE_URL + 'getPotentialCaptureForScout?scoutId=',
    GET_POTENTIAL_BY_PARENT_SCOUT_ID: BASE_URL + 'getPotentialCaptureForParentScout?parentScoutId=',
    GET_ALL_CLINIC_NAMES: BASE_URL + 'getAllClinicNameById?parentScoutId=',
    CREATE_CASHFREE_MANDATE_SUBSCRIPTION: BASE_URL + 'createSeamlessSubscriptionWithPlanInfo?userId=',
    CREATE_AUTH_REQUEST: BASE_URL + 'createAuthorisationRequest?userId=',
    GET_AUTH_PAYMENT: BASE_URL + 'getAuthStatusApi?loanId=',
    GET_NACH_DETAILS: BASE_URL + 'getRepaymentData?userId=',
    VERIFY_UPI_ID: BASE_URL + 'verifyHandel?userId=',
    GET_BANK_LIST_FOR_USERS: BASE_URL + 'getCashFreeSubscriptionPlanInfoDetail?userId=',
    GET_TXN_SUMMARY: BASE_URL + 'getMandateSummary?userId=',
    GET_EMI_CALCULATION: BASE_URL + 'getAmLoanCalculations?loanId=',
    CHECK_ELIGIBILITY_FOR_FM: BASE_URL + 'checkEligibilityForFM?userId=',
    CREATE_ORDER_FOR_FM: BASE_URL + 'createOrderForFM?userId=',
    GET_LOGO_API: BASE_URL + 'getFlexMoneyUserDetail?userId=',
    WEB_HOOK_CALL: BASE_URL + 'flexMoneyTransactionWebhook',
    GET_DIGITA_BANK_REPORT: BASE_URL + 'getDigitapBankStatementDetailByUserId?userId=',
    GET_SUBSCRIPTION_STATUS: BASE_URL + 'getSubscriptionDataFromCashFree?userId=',
    GE_ALL_SCOUT_FOR_PARENT_SCOUTS: BASE_URL + 'getAllScoutCodesByParentId?parentScoutId=',
    GET_PARENT_SCOUNT_LEADS_CONTS: BASE_URL + 'getAllDoctorCountAndStatusForParentScout?parentScoutId=',
    GET_LEADS_COUNT_BY_SCOUT_ID: BASE_URL + 'getDoctorDetailsByStatusForScout?scoutId=',
    GET_LIVE_CLINICS_BY_SCOUT_ID: BASE_URL + 'getActivePercentageForScout?scoutId=',
    GET_QR_INSTALLED_SCOUT_ID: BASE_URL + 'getQrNotInstalledForScout?scoutId=',
    GET_PRODUCT_MAPPED_BY_SCOUT_ID: BASE_URL + 'getProductNotMappedDetailsForScout?scoutId=',
    GET_INACTIVE_CLINICS: BASE_URL + 'getInActiveClinicForScout?scoutId=',
    SEARCH_API_DOCTOR_DETAILS: BASE_URL + 'searchDoctorDetail?searchBy=',
    GET_AVERAGE_PERCENTAGE_BY_SCOUT_ID: BASE_URL + 'getAverageApprovalRateScout?scoutId=',
    GET_BANK_LIST_FOR_USERS_API: BASE_URL + 'getBanksInformation?page_no=1&no_of_entry=300',
    GET_BS_INFO_API: BASE_URL + 'finzy/bankStatement?loanId=',
    ESTABLISH_ELIGIBILITY_API: BASE_URL + 'jp/establishEligibility?loanId=',
    GET_CLICKWRAP_AGGREEMENT_API: BASE_URL + 'api/click-wrap/getAgreementUrl?loanId=',
    GET_KFS_FOR_FIBE: BASE_URL + 'v1/getFibeKfsAgreementUrl?loanId=',



    ///ecom

    GET_DOCTOR_LIST_BY_GROUP: BASE_URL + 'getFilteredDoctorDetails?city=',
    SAVE_APPOINTMENT_API: BASE_URL + 'saveOrUpdateAppointmentDetails',


    ///

    SAVE_LOAN_DETAILS_API: BASE_URL + 'userDetails/saveLoanDetails',
    SAVE_BASIC_DATA_API: BASE_URL + 'userDetails/basicDetail',
    SEND_AADHAR_OTP_API: BASE_URL + 'aadhaarVerify/sendOtp?userId=',
    VERIFY_OTP_API: BASE_URL + 'aadhaarVerify/submitOtp?userId=',
    PHONE_PREFILL_API: BASE_URL + 'phoneToPrefill?userId=',
    PAN_VERIFY_API: BASE_URL + 'panVerify?userId=',
    GET_PHONE_PREFILL_DATA_API: BASE_URL + 'getPhoneToPrefillDetail?userId=',
    GET_USER_DETAILS_BY_USER_ID: BASE_URL + 'userDetails/getUserDetailsByUserId?userId=',
    SAVE_ADDRESS_DATA_API: BASE_URL + 'userDetails/addressDetail',
    SAVE_EMPLOYMNENT_DATA: BASE_URL + 'userDetails/employmentDetail',
    GET_USER_ADDRESS_DATA: BASE_URL + 'userDetails/getUserAddressByUserId?userId=',
    // GET_CREIF_DESCION: BASE_URL + 'getBureauDecision?doctorId=',
    UPLOAD_FILE: BASE_URL + 'uploadpdf',
    ADNVANCE_LIVELINESS_API: BASE_URL + 'advanceLiveliness?userId=',
    FACE_MATCH_API: BASE_URL + 'faceMatch?userId=',
    SAVE_BASE_64_IMG: BASE_URL + 'savePhotograph',
    INITIATE_CONTRACT: BASE_URL + 'initiateContract?loanId=',
    LOAN_DETAILS_BY_USER_ID: BASE_URL + 'userDetails/getLoanDetailsByUserId?userId=',
    GET_ESIGN_STATUS: BASE_URL + 'getUserAgreementSignStatus?loanId=',
    CREATE_MANDATE_REQUEST: BASE_URL + 'createMandateRequest?loanId=',
    GET_MANDATE_DETAILS: BASE_URL + 'getMandateDetails?loanId=',
    GET_FINDOC_DETAILS: BASE_URL + 'finDoc/callFinDocApis?loanId=',
    GET_BS_DECISION_API: BASE_URL + 'bsDecision?loanId=',
    // GET_EXPERIAN_REPORT: BASE_URL + 'experianBureauReport?loanId=',
    GET_CARDLESS_EMI: BASE_URL + 'jp/establishEligibility?loanId=',
    GET_STATUS_CARDLESS: BASE_URL + 'jp/orderStatusChecker?loanId=',
    GET_LEAD_SOURCE: BASE_URL + 'getLeadSource?userId=',
    GET_STATES_FINDOC: BASE_URL + 'finDoc/allFindocDistricts',
    GET_EXPERIAN_REPORT: BASE_URL + 'surePassBureau?userId=',
    GET_CREIF_DESCION: BASE_URL + 'bureauDecisionNew?loanId=',
    CHECK_AADHAR_VERIFY: BASE_URL + 'checkAadhaarVerification?userId=',
    CHECK_AGREEMENT_STATUS: BASE_URL + 'getUserAgreementSignStatus?loanId=',
    UPDATE_PRODUCT_API: BASE_URL + 'updateProductDetail?loanId=',
    UPDATE_TREATMENT_API: BASE_URL + 'updateTreatmentAndLoanAmount?loanId=',
    GET_DIGIO_SDK_DATA: BASE_URL + 'createMandateRequest?loanId=',
    INITIATE_CLICKWRAP_SIGNING: BASE_URL + 'api/click-wrap/initiateAgreement',
    CONSCENT_LOGS_API: BASE_URL + 'consent/log-consent?loanId=',
    CONSCENT_LOGS_API_USER_ID: BASE_URL + 'consent/log-consent?userId=',
    GET_CASHFREE_EMI: BASE_URL + 'cashfree/checkEligibility?loanId=',
    GET_REPAYMENT_SCHEDULE_API: BASE_URL + 'finDoc/repaymentScheduleApi?loanId=',
    GET_EMI_DETAILS_FINDOC: BASE_URL + "finDoc/getEmiDetails?loanId=",
    GET_LOAN_LIST_API: BASE_URL + "getLoanDetailsWithUserInfo?userId=",
    GET_CLICK_WRAP_DATA_API: BASE_URL + 'api/click-wrap/getClickWrapData?loanId=',
    GET_REMAININGLIMIT_API: BASE_URL + 'api/getRemainingLimit?userId=',
    GET_DISBURSE_API: BASE_URL + 'api/getDisburseDataPL?loanId=',
        CREATE_ZYPE_LEAD: BASE_URL + 'zype/createLead?loanId=',
            GET_ELIGIBILITY_RUN_POLICY: BASE_URL + 'eligibility/runPolicy?loanId=',
            GET_ELIGIBILITY_LIMIT_API: BASE_URL + 'eligibility/limit?loanId=',
    GET_BS_LIMIT_API: BASE_URL + 'bsLimit?loanId=',
    CALCULATE_BS_LIMIT:BASE_URL+'calculateBsLimit?loanId=',
        CALCULATE_LIMIT:BASE_URL+'eligibility/calculateLimit?loanId=',
        GET_LEAD_STATUS:BASE_URL+'finDoc/getFinDocDetails?loanId=',










































}
export {
    APIS,
    BASE_URL,

};